module.exports = __webpack_public_path__ + "svg/virgo.svg?489feaf4cd1edb4fd11f5baca01d4bfe";